export const TENANT_REFERENCING_UP_SELL_ROUTES = {
  BASE: 'TENANT:REFERENCING:UP_SELL:BASE',
  WELCOME: 'TENANT:REFERENCING:UP_SELL:WELCOME',
  INTEREST_IN_NO_DEPOSIT: 'TENANT:REFERENCING:UP_SELL:INTEREST_IN_NO_DEPOSIT',
  INTEREST_IN_NO_DEPOSIT_FEEDBACK: 'TENANT:REFERENCING:UP_SELL:INTEREST_IN_NO_DEPOSIT_FEEDBACK',
  BEFORE_THIRD_PARTY: 'TENANT:REFERENCING:UP_SELL:BEFORE_THIRD_PARTY'
};
